'use strict';

var BenchmarkCarriersDirective = function BenchmarkCarriersDirective() {
  return {
    restrict: 'E',
    template: require('../templates/benchmark-carriers.html'),
    scope: {},
    replace: true,
    controller: 'BenchmarkCarriersController'
  };
};
BenchmarkCarriersDirective.$inject = [];
module.exports = BenchmarkCarriersDirective;